import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { ONE_HOUR } from '@constants';
import { RoomsWithSpeakersResult } from '@common/types/api';

import { fetchRooms } from '../useLobbyQueries/queries';

export const useRoomsQuery = (page = 1) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'br';

  return useQuery<RoomsWithSpeakersResult, AxiosError>(
    ['rooms', page, currentLang],
    fetchRooms,
    {
      staleTime: ONE_HOUR,
    },
  );
};
